import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/ibm-garage-developer-guide/ibm-garage-developer-guide/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <PageDescription mdxType="PageDescription">
      <p>{`Office Hour meetings by the Garage Practitioner Activation Team`}</p>
    </PageDescription>
    <p>{`Office Hours materials can be downloaded from the `}<a parentName="p" {...{
        "href": "https://ibm.box.com/v/Office-Hours"
      }}>{`Office Hours`}</a>{` folder in Box.`}</p>
    <p>{`The channel for the recorded presentations is `}<a parentName="p" {...{
        "href": "https://www.youtube.com/channel/UCCv359rg3CxVGFttCp0Tzvg"
      }}>{`IBM Garage Cloud-Native Toolkit`}</a>{`.`}</p>
    <h2>{`April 30, 2020: Git 201`}</h2>
    <p>{`An overview of somewhat advanced scenarios for using Git and GitHub that we’re likely to run into.`}</p>
    <p>{`Presentation: `}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=BdbnOR-0qeg"
      }}>{`Office Hours - Git 201`}</a>{` (1:02 hrs)`}</p>
    <h2>{`April 16, 2020: Iteration Zero`}</h2>
    <p>{`An overview of how the `}<a parentName="p" {...{
        "href": "https://github.com/cloud-native-toolkit/ibm-garage-iteration-zero"
      }}>{`Iteration Zero`}</a>{` scripts work.`}</p>
    <p>{`Presentation: `}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=HKX6APL3Uf8"
      }}>{`Office Hours - Iteration Zero`}</a>{` (1:13 hrs)`}</p>
    <h2>{`April 2, 2020: Resource Access Management`}</h2>
    <p>{`Using Identity Access Management (IAM) to control access to resources`}</p>
    <p>{`Downloads are available in the `}<inlineCode parentName="p">{`Resource Access Management`}</inlineCode>{` folder.`}</p>
    <p>{`Presentation: `}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=eayMGvkLZmI"
      }}>{`Office Hours - Access Control`}</a>{` (1 hr)`}</p>
    <p><a parentName="p" {...{
        "href": "/dev-guide/toolkit-resources/resource-mgmt"
      }}>{`Resource Access Management`}</a>{` is an article that describes the content and includes the recording.`}</p>
    <p>{`Quotes from some satisfied listeners:`}</p>
    <ul>
      <li parentName="ul">{`“The IAM system is dauntingly complex. Thanks for this presentation and these scripts — they’re a really helpful starting point.”`}</li>
      <li parentName="ul">{`“This video will be a great asset to put on YouTube and the toolkit site for all those Admin and SREs creating the clusters and setting up the environment for a project.”`}</li>
      <li parentName="ul">{`“This is the first time I have seen a screen cast showing how IAM works, and how to get it configure and test it with demo users.”`}</li>
    </ul>
    <h2>{`March 26, 2020: Terraform`}</h2>
    <p>{`An overview of Terraform and the components used in the Toolkit.`}</p>
    <p>{`Presentation: `}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=WL2cOL3vNBg"
      }}>{`Office Hours - Terraform`}</a>{` (1.5 hrs)`}</p>
    <h2>{`IBM Garage Cloud Native Toolkit`}</h2>
    <p>{`An introduction to the IBM Garage Cloud Native Toolkit, the problems it solves and a demonstration of using it.`}</p>
    <p>{`Presentation: `}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=LcWboN1T7Zk"
      }}>{`IBM Garage Cloud Native Toolkit`}</a>{` (30 min)`}</p>
    <h2>{`Tekton concepts`}</h2>
    <p>{`What is Tekton and how is it used for continious integration?`}</p>
    <p>{`Presentation: `}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=2TWocBgwt8k"
      }}>{`Tekton 101`}</a>{` (7 min)`}</p>
    <h2>{`DevOps concepts`}</h2>
    <p>{`Learn about the purpose of a continuous delivery pipeline, the sorts of steps one typically performs, and the softs of tools used to implement those steps.`}</p>
    <p>{`Presentation: `}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=GOPWObjFTsI"
      }}>{`Overview of DevOps concepts with Red Hat OpenShift`}</a>{` (20 min)`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      